import React, { useState, useRef } from 'react';
import styled from 'styled-components';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Peer from 'peerjs';
// import ReactAudioPlayer from 'react-audio-player';

const Sandbox_call = () => {
  return (
    <>
      <h1>Sandbox</h1>

      <NewContactCard />
      <PeerTest />
    </>
  )
}

const NewContactCard = () => {
  return (
    <div>
      Fixed Contact Card
    </div>
  )
}

const StyledPeerTestDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  
  button {
    margin: 0.25em;
    padding: 0.25em;
    background-color: white;
    border: 1px solid black;
    height: 2em
  }
  input {
    margin: 0.25em;
    padding: 0.25em;
    border: 1px solid black;
    height: 2em
  }
` 

const PeerTest = () => {
  const peerRef = useRef();
  const [recv, setRecv] = useState('');
  const [id, setId] = useState('');
  const [onvideocall, setOnvideocall] = useState(false);
  const [onaudiocall, setOnaudiocall] = useState(false);
  const video = useRef();
  const [audioSrc, setAudioSrc] = useState('');

  const connect_peer = () => {
    peerRef.current = new Peer();
    peerRef.current.on('open', function (id) {
      setId(id)
      //send id to parse
    });

    peerRef.current.on('connection', (conn) => {
      conn.on('data', (data) => {
        console.log(data);
      });
    });

    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
    peerRef.current.on('call', (call) => {
      if (call.metadata.type === 'audio') {
        navigator.getUserMedia({ audio: true }, (stream) => {
          call.answer(stream); // Answer the call with an A/V stream.
          call.on('stream', (remoteStream) => {
            setOnaudiocall(true);
            setAudioSrc(remoteStream);
          });
        }, (err) => {
          console.error('Failed to get local stream', err);
        });
      } else if (call.metadata.type === 'video') {
        navigator.getUserMedia({ video: true, audio: true }, (stream) => {
          call.answer(stream); // Answer the call with an A/V stream.
          call.on('stream', (remoteStream) => {
            setOnvideocall(true); 
            video.current.srcObject = remoteStream;
          });
        }, (err) => {
          console.error('Failed to get local stream', err);
        });
      } else {
        console.log('Refactor this');
      }
    });
  }

  const send_hi = () => {
    const conn = peerRef.current.connect(recv);
    conn.on('open', () => {
      conn.send('hi!');
    });
  }
  const cancelvideocall =() =>{
      setOnvideocall(false);
  }

  const videocall = () => {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
    navigator.getUserMedia({ video: true, audio: true }, (stream) => {
      const call = peerRef.current.call(recv, stream, { metadata: { type: 'video' } });
      call.on('stream', (remoteStream) => {
        setOnvideocall(true);
        video.current.srcObject = remoteStream;
      });
    }, (err) => {
      console.error('Failed to get local stream', err);
    });
  }

  const audiocall = () => {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
    navigator.getUserMedia({ video: false, audio: true }, (stream) => {
      const call = peerRef.current.call(recv, stream, { metadata: { type: 'audio' } });
      call.on('stream', (remoteStream) => {
        setOnaudiocall(true);
        setAudioSrc(remoteStream);
      });
    }, (err) => {
      console.error('Failed to get local stream', err);
    });
  }

  return (
    <StyledPeerTestDiv>
      <div>
        <h1>PeerJS Test</h1>
      </div>
      <div>
        <button onClick={connect_peer}>Connect to PeerJS Server</button>
        <span>My peer ID is: {id}</span>
      </div>
      <div>
        <input type="text" placeholder="Reciever id"
          value={recv}
          onChange={e => { setRecv(e.target.value) }}
        />
        <button onClick={send_hi}>Send Hi! {recv}</button>
      </div>
      <div>
        <button onClick={videocall}>Video Call</button>
        <button onClick={cancelvideocall}>Cancel Video call</button>
      </div>
      {onvideocall &&
        <div>
          <span>Peer video:</span>
          <video ref={video} width="100" height="100" autoPlay="autoplay"></video>
        </div>
      }
      <div>
        <button onClick={audiocall}>Audio Call</button>
      </div>
      {onaudiocall &&
        <div>
          <span>Audio Call:</span>
          {/* <ReactAudioPlayer
            src={audioSrc}
            autoPlay
            controls
          /> */}
          {/* <audio controls>
            <source ref={audio} type="audio/wav" />
          </audio> */}
        </div>
      }
    </StyledPeerTestDiv>
  )
}

export default Sandbox_call;
